import { commonAPI } from '@/services-ts/axios'
import type { ICloneResource, ICreateResource, IUpdateResource } from '@/types/Request/CommonAPI'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useResourceStore = defineStore('resource', {
  actions: {
    async GetResourceList(LanguageId: string) {
      const data = await commonAPI.ResourceServices.GetResourceList(LanguageId)
      return data
    },

    async GetResourceForEdit() {
      const { status, data } = await commonAPI.ResourceServices.GetResourceForEdit()
      return status ? data : []
    },

    async CloneResource(payload: ICloneResource) {
      const { status } = await commonAPI.ResourceServices.CloneResource(payload)

      if (status) {
        await this.GetResourceForEdit()
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }

      return status
    },

    async CreateResource(payload: ICreateResource) {
      const { status } = await commonAPI.ResourceServices.CreateResource(payload)

      if (status) {
        await this.GetResourceForEdit()
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }

      return status
    },

    async UpdateResource(payload: IUpdateResource) {
      const { status } = await commonAPI.ResourceServices.SetResourceValue(payload)
      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
    },
  },
})
